import { useState, useRef, useEffect, ReactNode } from 'react';
import { BiLogOutCircle } from "react-icons/bi";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import { GrPowerReset } from 'react-icons/gr';
import { RiLockPasswordLine } from "react-icons/ri";

interface AppMenuProps {
    label: string;
    icon?: ReactNode;
    resetSerialKey?: () => void;
    logoutUser?: () => void;
    openPassword:()=>void;
}

const createMenuItems = (logoutUser?: () => void, resetSerialKey?: () => void, openPassword?:()=>void) => [
    {
        label: 'Profile',
        icon: <CgProfile size={16} className='menu-icon text-green-700 my-auto' />,
        onClick: () => console.log('Profile clicked')
    },
    {
        label: 'Help',
        icon: <IoMdHelpCircleOutline size={20} className='menu-icon text-blue-600 my-auto' />,
        onClick: () => console.log('Help clicked')
    },
    {
        label: 'Change Password',
        icon: <RiLockPasswordLine size={20} className='menu-icon text-pink-600 my-auto' />,
        onClick: openPassword
    },
    {
        label: 'Reset Serial key',
        icon: <GrPowerReset size={16} className='menu-icon text-orange-600 my-auto' />,
        onClick: resetSerialKey // Use function passed via props
    },
    {
        label: 'Logout',
        icon: <BiLogOutCircle size={16} className='menu-icon text-red-600 my-auto' />,
        onClick: logoutUser
    }
];

const AppMenu = (props: AppMenuProps) => {
    const [isMenuVisible, setMenuVisible] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const toggleMenu = () => setMenuVisible(!isMenuVisible);
    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setMenuVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative inline-block drop-shadow-2xl" ref={menuRef}>
            <button
                className="bg-transparent border-none cursor-pointer text-[14px] flex flex-row items-center text-green-600"
                onClick={toggleMenu}
                aria-controls="custom-menu"
                aria-haspopup="true"
            >
                <div className='text-[17px]'>{props.icon}</div>
                {props.label}
            </button>
            {isMenuVisible && (
                <div className="absolute top-full right-0 z-50">
                    <div className="relative">
                        <div className="absolute top-[-5px] right-1 mx-auto w-3 h-3 bg-white rotate-45"></div>
                        <ul className="py-2 px-1 rounded-md bg-white">
                            {createMenuItems(props.logoutUser, props.resetSerialKey).map((item, index) => (
                                <li onClick={item.onClick} key={index} className="flex text-nowrap flex-row my-auto justify-start gap-2 py-1 text-[13px] hover:cursor-pointer hover:bg-gray-100 px-4 rounded-md">
                                    {item.icon}
                                    {item.label}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AppMenu;
